import React from "react";

const EventStep = ({ formData, onChange }) => (
  <div>
    <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-2">
      Votre événement
    </h3>
    <p className="text-gray-500 text-sm mb-8">Quand et pour quelle occasion ?</p>
    <div className="space-y-5">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Date de l'événement <span className="text-[#E5007D]">*</span>
        </label>
        <input
          type="date"
          name="eventDate"
          value={formData.eventDate}
          onChange={onChange}
          required
          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Type d'événement
        </label>
        <input
          type="text"
          name="eventType"
          value={formData.eventType}
          onChange={onChange}
          className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm"
          placeholder="Mariage, anniversaire, baptême..."
        />
      </div>
    </div>
  </div>
);

export default EventStep;
